import styled from "styled-components";

interface IEditorInnerProps {}
export const LexicalEditorInnerContainer = styled.div<IEditorInnerProps>`
  li {
    list-style: initial !important;
  }
`;
